import React, { useEffect, useState } from "react";
import Utils from "../../../../../utils";
import Pagination from "react-js-pagination";
import { envelopeHistory } from "../../../../../services/CommonService";

const lengths = Utils.tableShowLengths();

function EnvHistory(props) {
    const [historyList, setHistoryList] = useState([]);
    const [totalHistory, setTotalHistory] = useState(0);
    const [dataParams, setDataParams] = useState({
        limit: lengths[0],
        page: 1,
    });

    useEffect(function () {
        if (props.envelopeData.id) {
            let obj = {
                id: props.envelopeData.id,
                timezone: props.envelopeData.time_zone,
                limit: dataParams.limit,
                page: dataParams.page
            };
            setHistoryList([]);
            setTotalHistory(0);

            envelopeHistory(obj)
                .then(response => {
                    setHistoryList(response.data.data);
                    setTotalHistory(parseInt(response.data.totalRecord));
                })
                .catch(err => {

                });
        }
    }, [props.envelopeData, dataParams]);

    const handleData = (e, type) => {
        let params = { ...dataParams };
        if (type === 'pagination') {
            params.page = e;
        } else if (type === 'limit') {
            params.limit = parseInt(e.target.value);
        }
        setDataParams(params);
    };

    return (
        <div className="tab-pane fade p-4 bg-light" id="History" role="tabpanel" aria-labelledby="History-tab">
            <div className="row mb-3">
                <div className="col-lg-6">
                    <div className="my-2 d-flex align-items-center flexWrap">
                        <div className="font_bold"> Sleeves Name :</div>
                        <div className="font-light ms-1">{props.envelopeData.envelope_name}</div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="my-2 d-flex align-items-center flexWrap">
                        <div className="font_bold"> Time Zone :</div>
                        <div className="font-light ms-1">{props.envelopeData.time_zone}</div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="my-2 d-flex align-items-center flexWrap">
                        <div className="font_bold"> Sleeves ID :</div>
                        <div className="font-light ms-1">{props.envelopeData.envelope_id}</div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="my-2 d-flex align-items-center flexWrap">
                        <div className="font_bold"> Sleeves Recipient :</div>
                        <div className="font-light ms-1">{props.envelopeData.recipient_names}</div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="my-2 d-flex align-items-center flexWrap">
                        <div className="font_bold"> Date Send :</div>
                        <div className="font-light ms-1">{props.envelopeData.send_date}</div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="my-2 d-flex align-items-center flexWrap">
                        <div className="font_bold"> User :</div>
                        <div className="font-light ms-1">{props.envelopeData.sender_name}</div>
                    </div>
                </div>
            </div>
            <div className="table-responsive mb-4">
  <h6 className="text-dark fw-semibold mb-3">
    Sleeves Activity History
  </h6>

  <table className="table table-hover align-middle border">
    {/* Table Head */}
    <thead className="bg-light">
      <tr>
        <th
          className="border text-secondary fw-semibold small"
          style={{ minWidth: "140px", padding: "10px" }}
        >
          Time
        </th>
        <th
          className="border text-secondary fw-semibold small"
          style={{ minWidth: "200px", padding: "10px" }}
        >
          User / IP
        </th>
        <th
          className="border text-secondary fw-semibold small"
          style={{ minWidth: "150px", padding: "10px" }}
        >
          Action
        </th>
        <th
          className="border text-secondary fw-semibold small"
          style={{ padding: "10px" }}
        >
          Activity Details
        </th>
      </tr>
    </thead>

    {/* Table Body */}
    <tbody>
      {historyList.length > 0 ? (
        historyList.map((item, index) => (
          <tr key={index}>
            {/* Time */}
            <td className="border" style={{ padding: "10px" }}>
              <span className="text-dark fw-medium">{item.created_at}</span>
            </td>

            {/* User/IP */}
            <td className="border" style={{ padding: "10px" }}>
              <div className="d-flex flex-column">
                <span className="fw-semibold text-dark">{item.sender_name}</span>
                <small className="text-muted">
                  <i className="fas fa-network-wired me-1"></i>
                  {item.ip_address}
                </small>
              </div>
            </td>

            {/* Action */}
            <td className="border" style={{ padding: "10px" }}>
              <span className="badge bg-primary bg-opacity-10 text-primary px-3 py-2 rounded-pill">
                {item.action}
              </span>
            </td>

            {/* Activity Details */}
            <td className="border" style={{ padding: "10px" }}>
              <span className="text-dark">{item.detail}</span>
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan={4} className="text-center py-5 text-muted">
            <div className="d-flex flex-column align-items-center">
              <i className="bi bi-inbox fs-1 mb-2"></i>
              <p className="mb-0">No activity found</p>
            </div>
          </td>
        </tr>
      )}
    </tbody>
  </table>
</div>


            {totalHistory > 10 && (
                <div className="table_footer_wrap mt-3">
                    <div className="d-flex align-items-center">
                        <span className="text-dark me-2">Show</span>
                        <select
                            className="form-select"
                             value={dataParams.limit}
                            style={{ width: "80px" }}
                            onChange={(e) => handleData(e, 'limit')}
                            aria-label="Default select example"
                        >
                            {lengths &&
                                lengths.map((item, i) => (
                                    <option value={item} key={i}>
                                        {item}
                                    </option>
                                ))}
                        </select>
                    </div>

                    <div className="pagination mb-4">
                        <Pagination
                            activePage={dataParams.page}
                            itemsCountPerPage={dataParams.limit}
                            totalItemsCount={totalHistory}
                            pageRangeDisplayed={5}
                            onChange={(e) => handleData(e, 'pagination')}
                        />
                    </div>
                </div>
            )}

        </div>
    );
}

export default EnvHistory;